import React from 'react'

const AboutSection2 = () => {
  return (
    <div className='backdiv'>
          <div className="visiongrid">
          <div className="vision_img_div">
            <img src="/vision.webp" alt="vissiont" className="img-cover" loading='lazy'/>
          </div>
       
            <div className="vision_cont_div">
              <div>
              <h2 className='sapt-head '>Vision</h2>
              <p className='main-content'>To excel in the areas of interest of the group and adding more feathers as per our expertise and strength, adapting to newer dimensions, businesses, technologies and markets and emerge as the leader while establishing <b>TRUST & GROWTH</b> .</p>
           </div>
            </div>
          </div>
      
    <div className="visiongrid">       
            <div className="vision_cont_div">
              <div>
                 <h2 className='sapt-head'>Mission</h2>
            <p className='main-content'>To conduct a business model which takes the responsibility towards the society & country while providing excellence and high standards in the product offered accepting to pioneering new technologies and practices maintaining the integrity in our work towards everyone creating a unified platform to build caring and collaborative relationships based on <b>Trust and mutual respect</b>.</p>
           </div>
            </div>
             <div className="vision_img_div">
             <img src="/mission.webp" alt="mission" className="img-cover" loading='lazy'/>
          </div>
          </div>




     
    </div>
  )
}

export default AboutSection2